import { useEffect } from "react";
import Swal from "sweetalert2";
import "./uploadStyles.css";

export const FileUploadModal = ({ status, onClose, onSubmit }) => {
  useEffect(() => {
    if (!status) return;
    let selectedFile = null;
    Swal.fire({
      title: "Upload Excel File",
      html: `
        <div id="drop-zone" class="manual-dropzone">
          <p id="drop-message">Drag and drop an Excel file here or click to select</p>
          <input type="file" id="fileInput" accept=".xls,.xlsx" hidden />
          <button id="selectButton" class="upload-btn">Choose File</button>
          <div id="file-name" class="file-preview"></div>
          <div id="file-error" style="color:red;margin-top:5px;"></div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
      willClose: () => {
        onClose(); // Called when modal closes (cancel)
      },
      preConfirm: () => {
        if (!selectedFile) {
          Swal.showValidationMessage(
            "Please select a valid Excel file before submitting."
          );
          return false;
        }
        onSubmit(selectedFile); // Notify parent
        return false; // Don't close modal automatically
      },
      didOpen: () => {
        const dropZone = document.getElementById("drop-zone");
        const fileInput = document.getElementById("fileInput");
        const selectButton = document.getElementById("selectButton");
        const fileNameDisplay = document.getElementById("file-name");
        const fileErrorDisplay = document.getElementById("file-error");

        const allowedTypes = [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
          "application/vnd.ms-excel", // .xls
        ];

        const updateFilePreview = (file) => {
          fileNameDisplay.innerHTML = `
            <span>${file.name}</span>
            <span id="deleteFile" style="cursor:pointer;color:red;margin-left:10px;">❌</span>
          `;
          fileErrorDisplay.innerText = "";

          document.getElementById("deleteFile").onclick = () => {
            selectedFile = null;
            fileNameDisplay.innerHTML = "";
            fileErrorDisplay.innerText = "";
          };
        };

        const handleFile = (file) => {
          if (
            file &&
            (allowedTypes.includes(file.type) ||
              file.name.match(/\.(xlsx|xls)$/i)) // Only .xls or .xlsx
          ) {
            selectedFile = file;
            updateFilePreview(file);
          } else {
            fileErrorDisplay.innerText =
              "Invalid file. Please upload an Excel file (.xls or .xlsx) only.";
            selectedFile = null;
            fileNameDisplay.innerHTML = "";
          }
        };

        dropZone.addEventListener("dragover", (e) => {
          e.preventDefault();
          dropZone.classList.add("drag-over");
        });

        dropZone.addEventListener("dragleave", () => {
          dropZone.classList.remove("drag-over");
        });

        dropZone.addEventListener("drop", (e) => {
          e.preventDefault();
          dropZone.classList.remove("drag-over");
          const file = e.dataTransfer.files[0];
          handleFile(file);
        });

        selectButton.addEventListener("click", () => fileInput.click());

        fileInput.addEventListener("change", (e) => {
          const file = e.target.files[0];
          handleFile(file);
        });
      },
    });
  }, [status]);

  return null; // This component only triggers Swal modal, no UI to render
};
